"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _formik = require("formik");

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _ColorPicker = _interopRequireWildcard(require("../ColorPicker"));

var _Button = _interopRequireDefault(require("../Button"));

var _FormErrorMessage = _interopRequireDefault(require("../FormErrorMessage"));

var _index = _interopRequireDefault(require("./index"));

var _constants = require("../../utils/constants");

var _default = function _default(_ref) {
  var label = _ref.label,
      onSubmit = _ref.onSubmit,
      onDelete = _ref.onDelete,
      theme = _ref.theme,
      onClose = _ref.onClose,
      validate = _ref.validate;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var labelClassNames = 'text-gray-light font-semibold uppercase mb-1';
  var sectionClassNames = 'mb-2';

  function isEnableToSubmit(formikProps) {
    var dirty = formikProps.dirty,
        errors = formikProps.errors;
    return (label.isNew || dirty) && (0, _isEmpty["default"])(errors);
  }

  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    onSubmit: onSubmit,
    initialValues: {
      name: label.name,
      color: !!label.color ? label.color : _constants.COLORS[0]
    },
    validate: validate,
    render: function render(formikProps) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "p-8 bg-card",
        style: {
          width: 400
        }
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: sectionClassNames
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: labelClassNames
      }, "Name"), /*#__PURE__*/_react["default"].createElement(_formik.Field, {
        autoFocus: true,
        name: "name",
        autoComplete: "off",
        className: "w-full text-2xl font-bold border-b rounded-none bg-transparent"
      }), /*#__PURE__*/_react["default"].createElement(_FormErrorMessage["default"], {
        name: "name",
        showAfterTouch: false
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: sectionClassNames
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: labelClassNames
      }, "Color"), /*#__PURE__*/_react["default"].createElement(_ColorPicker["default"], {
        theme: theme,
        Cell: Cell,
        value: formikProps.values.color,
        onChange: function onChange(color) {
          return formikProps.setFieldValue('color', color);
        }
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "my-8 font-semibold"
      }, !label.isNew && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-gray-light"
      }, t('settings.label.delete.text')), ' ', /*#__PURE__*/_react["default"].createElement("span", {
        className: "cursor-pointer select-none text-primary",
        onClick: onDelete
      }, t('button.deleteNow')))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "w-full"
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        size: "sm",
        type: "button",
        color: "secondary",
        className: "w-2/5 mr-2",
        onClick: onClose
      }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        size: "sm",
        type: "submit",
        disabled: !isEnableToSubmit(formikProps),
        className: "w-2/5",
        onClick: formikProps.handleSubmit
      }, t('button.save'))));
    }
  });
};

exports["default"] = _default;

function Cell(_ref2) {
  var color = _ref2.color,
      checked = _ref2.checked,
      theme = _ref2.theme,
      onClick = _ref2.onClick;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-center flex-1"
  }, /*#__PURE__*/_react["default"].createElement(_ColorPicker.ColorCell, {
    color: color,
    checked: checked,
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(_index["default"], {
    theme: theme,
    className: "w-8 h-8 select-none rounded-full flex items-center justify-center",
    color: color
  }, "Aa")));
}
//# sourceMappingURL=LabelDetail.js.map